/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReleaseNotesStateDto } from '../../models/release-notes-state-dto';

export interface GetReleaseNotesState$Params {
  'X-API-Version'?: string;
}

export function getReleaseNotesState(http: HttpClient, rootUrl: string, params?: GetReleaseNotesState$Params, context?: HttpContext): Observable<StrictHttpResponse<ReleaseNotesStateDto>> {
  const rb = new RequestBuilder(rootUrl, getReleaseNotesState.PATH, 'get');
  if (params) {
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReleaseNotesStateDto>;
    })
  );
}

getReleaseNotesState.PATH = '/api/release-notes/state';
